import styled from 'styled-components';

const ShipmentTypeModal = styled.div`
  ul {
    padding-left: 20px;
  }

  li {
    list-style-type: disc;
  }
`;

export { ShipmentTypeModal };
